import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PartnerSummaryDTO } from 'src/app/models/PartnerSummaryDTO.model';
import { DistributorsService } from 'src/app/services/distributors.service';
import { SimpleRequestDTO } from 'src/app/shared/models/SimpleRequest';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-view-distributor',
    templateUrl: './view-distributor.component.html',
    styleUrls: ['./view-distributor.component.css'],
    imports: [FormsModule]
})
export class ViewDistributorComponent {
  currentDistributorId?: number = undefined;

  request: SimpleRequestDTO = {} as SimpleRequestDTO;
  information: string = '';
  distributorSummary: PartnerSummaryDTO = {} as PartnerSummaryDTO;
  textoBusqueda: string = '';
  filteredPartners: any[] = [];
  camposBusqueda: string[] = [
    'customerId',
    'customerName',
    'customerEmail',
    'customerPhone',
    'numberPlans'
  ];

  constructor(
    private route: ActivatedRoute,
    private distributorsService: DistributorsService,
    private router: Router,
    public paginationService: PaginationService,
    public permissionsService: ValidatePermissionsService
  ) {}

  ngOnInit() {
    this.permissionsService.validateAccessLevels(MODULE_ID.Distributors);
    this.route.params.subscribe(params => {
      this.currentDistributorId = params['id'];
      this.information = 'Distributor ID ' + params['id'];
      this.request.id = params['id'];
      this.distributorsService.getDistributorSummary(this.request).subscribe(
        ({ StatusCode, Message, Data }) =>
          Data != null
            ? this.handleSaveSuccess(Data)
            : this.handleSaveError(StatusCode),
        () => {
          this.clearFields();
        }
      );
    });
  }

  handleSaveSuccess(data: PartnerSummaryDTO) {
    this.distributorSummary = data;
  }

  handleSaveError(statusCode: number) {}

  clearFields() {}

  goBack() {
    this.router.navigate(['/distributors']);
  }

  onSearchChange(): void {
    this.paginationService.currentPage = 1;
    this.filteredPartners = this.paginationService.updatePagination(
      this.distributorSummary.listCustomers, this.textoBusqueda, this.camposBusqueda
    );
  }
}
